module.exports = __webpack_public_path__ + "img/img13.e3090e7a.png";